<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('SaleProductManagerContracts') + saleProductManagerName"
      :active.sync="showModal"
    >
      <form>
        <div class="vx-row mb-6" v-has-permission="permission46">
          <div class="vx-col lg:w-5/6 w-full">
            <label class="vs-select--label">{{ $t("Contract") }}</label>
            <v-select
              label="title"
              name="contract"
              :options="allContracts"
              :reduce="x => x.id"
              v-model="contractModel.contractId"
              v-validate="'required'"
              ref="contractSelected"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('contract')">{{
              errors.first("contract")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn mt-6"
              @click.prevent="assignContract()"
            ></vs-button>
          </div>
        </div>
      </form>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[{ title: $t('ContractName') }, { title: $t('Action') }]"
      >
        <template slot-scope="{ row }">
          <td style="width: 76%">
            {{ row.contractTitle }}
          </td>
          <td style="width: 20%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="unassignContract(row.contractId)"
              class="d-inline"
              v-has-permission="permission47"
            ></vs-button>
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
const dict = {
  custom: {
    contract: {
      required: "لطفا قرارداد را انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_SaleProductManagers_ContractsPopup",
  props: {
    show: { default: false },
    model: {
      default: {}
    },
    keywords: {}
  },

  data() {
    return {
      permission46: "",
      permission47: "",
      gridDataSource: { data: [] },
      gridSearchData: {},
      saleProductManagerName: "",
      contractModel: {
        saleProductManagerId: null,
        contractId: null
      }
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    },
    ...mapGetters({
      allContracts: "sale/listContract"
    })
  },
  methods: {
    ...mapActions({
      assignContractInfo: "sale/assignContractToSaleProductManager",
      unassignContractInfo: "sale/unassignSaleProductManagerContract",
      fetchContract: "sale/fetchContractList"
    }),
    assignContract() {
      this.contractModel.saleProductManagerId = this.model.saleProductManagerId;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.assignContractInfo(this.contractModel).then(() => {
            this.$vs.notify({
              title: "عملیات موفق",
              text: "قرداد مورد نظر با موفقیت اضافه شد!",
              color: "success"
            });
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    unassignContract(contractId) {
      var saleProductManagerId = this.model.saleProductManagerId;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.unassignContractInfo({ saleProductManagerId, contractId }).then(
            () => {
              this.$refs.grid.renderGrid();
            }
          );
        }
      });
    }
  },
  watch: {
    show() {
      if (this.show == true) {
        this.fetchContract();
        if (this.model.saleProductManagerName) {
          this.saleProductManagerName = "،" + this.model.saleProductManagerName;
        } else {
          this.saleProductManagerName = "";
        }
        this.$validator.reset();
        this.gridDataSource = {
          type: "app",
          service:
            "Sales/api/SaleProductManagerQuery/" +
            this.model.saleProductManagerId +
            "/contracts-info"
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      } else {
        this.gridDataSource = { data: [] };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    }
  },
  components: {
    DataGrid,
    "v-select": vSelect
  }
};
</script>
